import React, { useRef, useEffect } from 'react';
import { IconLock, IconHide, IconShow } from '@lessonnine/design-system.lib';
import InputFrame from './InputFrame';

import { t } from 'src/viewLayer/helpers/translations';

export default ({
  value,
  onChangeHandler,
  errorKey,
  isFocused,
  setFocus,
  toggleVisibility,
  disabled,
  isVisible
}) => {
  const PasswordInputRef = useRef();

  useEffect(() => {
    if (isFocused) PasswordInputRef.current.focus();
  }, [isFocused]);

  return (
    <InputFrame errorKey={ errorKey } disabled={disabled} focused={isFocused}>
      <div className="icon-lock">
        <IconLock/>
      </div>
      <input
        id="uat-password-input-field"
        className="input-field"
        type={ isVisible ? 'text' : 'password'}
        autoComplete="new-password"
        name="password"
        placeholder={ t('password.placeholder') }
        value={value}
        ref={PasswordInputRef}
        onChange={onChangeHandler}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        disabled={disabled}
      />
      <div
        className="icon-end-right"
        onClick={ toggleVisibility }
        disabled={disabled}
      >
        { isVisible ? <IconShow /> : <IconHide /> }
      </div>
    </InputFrame>
  );
};

